module.exports = __webpack_public_path__ + "img/top10FilterOn.4b752395.svg";